export default __webpack_public_path__ + "static/media/ic_glp_custom.e906ef8f.svg";